var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsuarioRegistradoIc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27,
    stroke: "#333333",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(0.83717105,0,0,0.83717105,6.0460526,2.8338816)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-183,-684)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(183,684)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "22.139857,9.9059198 26.5,9.0583113 30.794265,9.9059198 33.806052,13.005296 34.589749,18.05302 34.589749,21.381428 35.431071,23.309659 33.14871,26.166592 30.299111,32.279432 30.794265,34.016171 35.79044,36.141761 43.548867,41.473627 45.131736,44.963175 8.385948,45.258424 8.385948,44.460013 9.4511332,41.837688 13.687999,37.568464 22.480319,34.016171 22.480319,31.396542 19.24793,24.988322 17.75639,22.382005 18.630402,20.00912 18.630402,13.993719 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.657105,38.162886 C 44.128258,40.064016 46,42.369776 46,44.871374 V 46 H 44.88066 8.1193399 7 v -1.128626 c 0,-2.501297 1.8717418,-4.807358 4.342596,-6.708488 3.578243,-2.753173 8.552522,-4.743485 10.43532,-5.045376 0.01912,-0.0033 0.009,-0.632404 -8.97e-4,-1.090061 -0.71027,-0.806549 -2.43679,-2.987877 -3.101641,-5.799802 -0.315543,-0.159984 -0.59971,-0.396495 -0.848618,-0.692059 -0.340045,-0.403426 -0.612859,-0.929776 -0.796925,-1.507045 -0.176298,-0.553165 -0.275204,-1.15755 -0.275204,-1.742953 0,-0.905673 0.228888,-1.803814 0.755988,-2.49497 l -0.0012,-0.01175 C 17.447272,19.193165 17.35225,18.304666 17.35225,17.299568 17.35225,13.515084 18.555257,8 26.5,8 c 7.944743,0 9.14775,5.514783 9.14775,9.299568 0,1.005098 -0.09502,1.893899 -0.157473,2.479603 l -0.0012,0.01145 c 0.5271,0.691156 0.755988,1.589297 0.755988,2.49497 0,0.585403 -0.09891,1.189788 -0.275204,1.742953 -0.183767,0.576967 -0.456879,1.103619 -0.796626,1.507045 -0.248908,0.295564 -0.533075,0.532075 -0.848917,0.692059 -0.664552,2.811925 -2.391072,4.993253 -3.101342,5.800103 -0.01016,0.457657 -0.02002,1.086446 -8.97e-4,1.08976 1.882798,0.301891 6.857077,2.292203 10.435021,5.045376 z m 1.891762,5.579861 c -0.478394,-1.309399 -1.718752,-2.613978 -3.247162,-3.789907 -3.290787,-2.531726 -7.762469,-4.345784 -9.429526,-4.613328 -1.844551,-0.295865 -1.867858,-3.752848 -1.868157,-3.76279 l -0.0054,-0.475132 0.328989,-0.331719 c 0.0069,-0.0072 2.414977,-2.410608 2.936101,-5.621138 l 0.154185,-0.948154 h 0.947824 c 5.97e-4,0 0.03944,-0.0458 0.102193,-0.119913 0.151496,-0.179869 0.281179,-0.439279 0.376798,-0.739964 0.103687,-0.324488 0.161656,-0.689951 0.161656,-1.055112 0,-0.522133 -0.117731,-0.999073 -0.397118,-1.238597 l -0.41893,-0.358533 0.0254,-0.54955 c 0.0078,-0.171735 0.02779,-0.359437 0.05319,-0.597756 0.05558,-0.520326 0.139843,-1.310304 0.139843,-2.241586 0,-2.865855 -0.908679,-7.042315 -6.908771,-7.042315 -6.000391,0 -6.908771,4.17646 -6.908771,7.042315 0,0.931282 0.08426,1.720959 0.139544,2.241284 0.0257,0.238319 0.04542,0.426323 0.05349,0.598058 l 0.0254,0.54955 -0.41893,0.358533 c -0.279686,0.239524 -0.397118,0.716464 -0.397118,1.238597 0,0.365161 0.05797,0.730624 0.161357,1.055112 0.09592,0.300685 0.225601,0.560095 0.377097,0.739964 0.06245,0.07412 0.101297,0.119913 0.102193,0.119913 h 0.947824 l 0.153886,0.948154 c 0.521423,3.21053 2.929229,5.613907 2.9364,5.621138 l 0.328989,0.331719 -0.0054,0.475132 c -2.99e-4,0.0099 -0.0239,3.466925 -1.868455,3.76279 -1.667058,0.267544 -6.138441,2.081602 -9.429229,4.613328 -1.528409,1.175929 -2.7690658,2.480508 -3.2471608,3.789907 z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.13237,
      strokeOpacity: 1
    },
    width: 19.90625,
    height: 6.15625,
    x: 25.84375,
    y: 37.21875
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "15.1694px",
      fill: "#000000",
      strokeWidth: 1.26412
    },
    x: 27.317303,
    y: 49.711823
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 27.317303,
    y: 49.711823,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "15.1694px",
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#398d4d",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.26412,
      strokeOpacity: 1
    }
  }, "***")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuarioRegistradoIc);
export default __webpack_public_path__ + "static/media/usuario-registrado-ic.d7b3a885.svg";
export { ForwardRef as ReactComponent };